<template>
  <div>
    <span
      @click="dialog = true"
      style="cursor: pointer"
      title="Editar"
    >
      {{ Helpers.formatarValorComCasas(item.lote_minimo, 2) }}
    </span>

    <SysDialog
      v-model="dialog"
      :titulo="TITULO_DIALOG"
      :largura="LARGURA_DIALOG"
      @click:primary="editar()"
    >
      <p v-if="produtos_selecionados.length > 0">
        <v-icon color="orange">mdi-alert</v-icon>
        A alteração será aplicada aos itens previamente marcados.
      </p>

      <TextFieldFormatadorDeValor
        v-model="editar_item.lote_minimo"
        outlined
        class="mb-n3"
        :error-messages="LOTE_MINIMO_ERRORS"
        @input="$v.editar_item.lote_minimo.$touch()"
        @blur="$v.editar_item.lote_minimo.$touch()"
      />
    </SysDialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { required, decimal } from "vuelidate/lib/validators";
import { editarLoteMinimo } from "../Api";

const verificarMaiorQueZero = (value) => value > 0;

export default {
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    produtos_selecionados: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    editar_item: {}
  }),
  validations: {
    editar_item: {
      lote_minimo: { required, decimal, verificarMaiorQueZero },
    }
  },
  watch: {
    dialog(valor) {
      if(valor) this.editar_item = Object.assign({}, this.item);
    }
  },
  computed: {
    TITULO_DIALOG() {
      return 'Editar lote minimo';
    },
    LARGURA_DIALOG() {
      return 450;
    },
    LOTE_MINIMO_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.lote_minimo.$dirty) return errors;
      !this.$v.editar_item.lote_minimo.decimal && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.lote_minimo.verificarMaiorQueZero && errors.push("Deve ser maior que 0 (Zero).");
      return errors;
    },
  },
  methods: {
    editar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let parametros = {
          grupo: this.editar_item.id_grupo,
          filial: this.editar_item.filial,
          lote_minimo: this.editar_item.lote_minimo,
          produtos: []
        };

        parametros.produtos = this.produtos_selecionados.length == 0 ? [this.editar_item] : this.produtos_selecionados;

        this.$store.dispatch(
          'loading/addRequisicao',
          editarLoteMinimo(parametros)
            .then(() => {
              this.$emit('atualizar-tela-inicial');
              this.dialog = false;
            })
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
</script>

<style>

</style>
